import React from "react";

const AddPractice = () => {
  return <div>AddPractice</div>;
};
export default AddPractice;
